<template>
  <div class="iv-con-nav">
    <div class="iv-si-think">
      <!-- <p class="iv-heart-letter"><span class="span1">管理者思想</span><span class="span2" @click="goToList">...</span> </p> -->
      <div class="iv-si-con">
        <ul>
          <template v-for="item in movieList">
            <li class="iv-list-li" :key='item.id' @click="todetail(item)">
              <div class="left">
                <img :src="getImgPath(item.blogPic)" @error="nofind"/>
<!--                <img class="iv-zd" src="@/assets/images/zhiding.png" v-if="item.orderNum"/>-->
              </div>
              <div class="right">
                <p class="title" :title="item.title">{{ item.title }}</p>
                <p class="content" :title="item.blogDesc">{{ item.blogDesc }}</p>
                <div class="time-box">
                  <p class="time">{{ getTime(item.publishTime) }}</p>
                  <span class="toTop" v-show="item.top>0"></span>
                </div>
              </div>
            </li>

            <!-- <li class="iv-list-li" v-else :key='item.title' @click="todetail(item.infoId)">
              <div class="left1">
                <p class="title">{{item.title}}</p>
                <p class="content">{{item.summary}}</p>
                <p class="time">{{getTime(item.publishDate)}}</p>
              </div>
              <div class="right1">
                <img :src="getImgPath(item.coverPicId)" @error="nofind"/>
                <img class="iv-zd" src="@/assets/images/zhiding.png" v-if="item.orderNum"/>
              </div>
            </li> -->
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import news from '../../../../../index/components/news-center/news.js'
// import info from './info.js'
// import {newsPrefixPath} from '@/config'
import {timeFormat} from '@/utils'
import Iconfont from '@/components/iconfont'

export default {
  data() {
    return {
      movieList: [],
      zdUrl: '@/assets/images/zhiding.png',
      navMap: {}
    }
  },
  props: ['navData'],
  created() {
    // this.initTabs()
    this.getmanagerThought()
  },
  watch: {
    navData(val) {
      this.navMap = val
    }
  },
  methods: {
    getmanagerThought() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'manager_idea',
          rowNum: '2'
        }
      }).then(({data}) => {
        this.movieList = data.data['manager_idea']
      })
    },
    getImgPath(imageUrl) {
      console.log("getImgPath==管理者思想",process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_LUNBO_API + imageUrl)
      // return id ? `${newsPrefixPath}file/downloadFile?fileId=${id}` : require('@/assets/images/news/default-pic.png')
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_LUNBO_API + imageUrl
    },
    getTime(d) {
      return timeFormat(d)
    },
    todetail(item) {
      const {href} = this.$router.resolve({
        name: 'newsDetail',
        query: {
          infoId: item.id,
          categoryName:item.columnName
        }
      })
      window.open(href, '_blank')
    },
    goToList() {
      const {href} = this.$router.resolve({
        name: 'manager_idea',
        query: {
          categoryCode: 'manager_idea',
          categoryName: '管理者思想',
          categoryId: this.navMap['manager_idea'].categoryId,
          categoryType: this.navMap['manager_idea'].categoryType
        }
      })
      window.open(href, '_blank')
    },
    nofind() {
      var img = event.srcElement
      img.src = require('@/assets/images/news/default-pic.png')
      img.onerror = null
    }
  },
  components: {
    Iconfont
  }
}
</script>

<style lang="scss" scoped>
.iv-list-li {
  cursor: pointer;
}

.iv-con-nav {
  // margin-top: 40px;
  .iv-si-think {
    width: 100%;
    // height: 71px;
    font-size: 32px;
    display: inline-block;
    // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 38px;
    background-color: #fff;
  }

  .iv-heart-letter {
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    height: 71px;
    line-height: 71px;
    width: 1200px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 30px;

    .span1 {
      float: left;
      border-top: 2px solid #FFC757;
      height: 30px;
      font-family: "Microsoft YaHei";
    }

    .span2 {
      float: right;
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
    }
  }

  .iv-si-con {
    ul {
      li {
        margin-top: 10px;
        height: 124px;
        display: flex;

        .left {
          // width: 250px;
          // height: 140.625px;
          // height: 56.25vmin;
          position: relative;

          .iv-zd {
            position: absolute;
            left: 0;
            top: 0;
            width: 40px;
            height: 40px;
          }

          img {
            width: 220px;
            //width: 186px;
            height: 124px;
            object-fit: cover;
          }
        }

        .right1 {
          // width: 250px;
          // height: 140.625px;
          position: relative;

          .iv-zd {
            position: absolute;
            left: 0;
            top: 0;
            width: 40px;
            height: 40px;
          }

          img {
            width: 250px;
          }
        }

        .right {
          width: 100%;
          line-height: 24px;
          margin-left: 20px;

          .title {
            font-size: 16px;
            font-weight: 600;
            color: rgba(0, 0, 0, .88);
            line-height: 24px;
            // margin-top: 10px;
            font-family: "Microsoft YaHei";
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .content {
            font-size: 16px;
            font-family: "Microsoft YaHei";
            color: rgba(0, 0, 0, .4);
            line-height: 24px;
            margin-top: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }

          .time-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-content: center;

            .time {
              font-size: 16px;
              color: rgba(0, 0, 0, .88);
              margin-top: 8px;
              font-weight: 400;
            }

            .toTop {
              background: url("~@/assets/images/icon-top.png") no-repeat;
              background-size: 18px;
              display: inline-block;
              width: 18px;
              height: 18px;
              margin-right: 5px;
              margin-top: 8px;
            }
          }
        }

        .left1 {
          width: 927px;
          float: left;

          .title {
            font-size: 16px;
            font-weight: 600;
            color: rgba(0, 0, 0, .85);
            line-height: 24px;
            font-family: "Microsoft YaHei";
            margin-top: 10px;
          }

          .content {
            font-size: 16px;
            font-family: "Microsoft YaHei";
            color: rgba(0, 0, 0, .64);
            line-height: 24px;
            margin-top: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .time {
            font-size: 14px;
            font-family: "Microsoft YaHei";
            color: rgba(0, 0, 0, .64);
            margin-top: 18px;
          }
          
        }
      }
    }
  }
}
</style>